var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26682 12.1411C5.06512 12.1411 4.07469 13.0869 4.07469 14.3332C4.07469 14.7426 3.74284 15.0744 3.33349 15.0744C2.92413 15.0744 2.59229 14.7426 2.59229 14.3332C2.59229 12.2462 4.26851 10.6587 6.26682 10.6587H9.66682C11.7538 10.6587 13.3414 12.3349 13.3414 14.3332C13.3414 14.7426 13.0095 15.0744 12.6002 15.0744C12.1908 15.0744 11.859 14.7426 11.859 14.3332C11.859 13.1315 10.9132 12.1411 9.66682 12.1411H6.26682Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6245 4.05819C8.70435 3.20003 7.31162 3.20262 6.39432 4.06596C5.52922 4.88017 5.53125 6.32117 6.42644 7.27231C7.24065 8.1374 8.68165 8.13537 9.63279 7.24018C10.5152 6.40964 10.5415 4.98358 9.6245 4.05819ZM10.6579 2.97088C9.16018 1.56412 6.86292 1.56505 5.36627 2.97366C3.81367 4.43493 3.95385 6.8338 5.33414 8.30035C6.79542 9.85296 9.19428 9.71277 10.6608 8.33248C12.1926 6.89083 12.1697 4.48493 10.6799 2.99218C10.6763 2.9886 10.6727 2.98504 10.6691 2.98151C10.6654 2.97792 10.6616 2.97437 10.6579 2.97088Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.3584acad55e136ae6bd47c27ee5cd38d.svg";
export { ForwardRef as ReactComponent };